import editableTextarea from "./editableTextarea.component";

const editableTextareaModule = angular
  .module("app.components.editableTextarea", [])
  .component("editableTextarea", editableTextarea);

export default editableTextareaModule;



// WEBPACK FOOTER //
// ./src/components/editableTextarea/editableTextarea.module.js